import { render } from "./AgendamentoIndex.vue?vue&type=template&id=582348ec&scoped=true&ts=true"
import script from "./AgendamentoIndex.vue?vue&type=script&lang=ts"
export * from "./AgendamentoIndex.vue?vue&type=script&lang=ts"

import "./AgendamentoIndex.vue?vue&type=style&index=0&id=582348ec&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582348ec"]])

export default __exports__